import {Banner} from '@primer/react'

export type RedundantProtectedBranchesBannerProps = {
  onClick: () => void
  onDismiss: () => void
}

export function RedundantProtectedBranchesBanner({onClick, onDismiss}: RedundantProtectedBranchesBannerProps) {
  return (
    <Banner
      data-react-autofocus
      variant="info"
      title="You have branch protection rules that can be removed"
      description="This repository has branch protection rules that are fully covered by rulesets and can be removed without affecting your repository's protection."
      primaryAction={<Banner.PrimaryAction onClick={onClick}>Manage protected branches</Banner.PrimaryAction>}
      onDismiss={onDismiss}
      className="mb-3"
    />
  )
}
